import Client from '@ubo/blitz';

// When deloying a new version of the configurator update the configurator-{version}.css file in the public folder and the FlexContent. Don't forget to remove the Bootstrap CDN import from the stylesheet!

export default function Configurator() {
  return <Client />;
}